import { reportingPrisma as prisma } from "client";

export const getRegistrationByEventCategorySummary = async ({
  searchParams,
  chartId,
  whiteLabelId,
  organizationId,
  lang = "en",
}: {
  searchParams: { [key: string]: string };
  chartId: number;
  whiteLabelId?: string;
  organizationId?: string;
  lang?: string;
}) => {
  try {
    let filtrationStages: any[] = [];
    let fromDate: Date;
    let toDate: Date;

    if (searchParams[`whiteLabelIds${chartId}`] || whiteLabelId) {
      const whiteLabelIds = searchParams[`whiteLabelIds${chartId}`]?.split(
        ","
      ) || [whiteLabelId];

      filtrationStages = [
        ...filtrationStages,
        {
          $match: {
            "event.whiteLabelId": { $in: whiteLabelIds.map((id) => ({ $oid: id })) },
          },
        },
      ];
      if (searchParams[`eventIds${chartId}`]) {
        const eventIds = searchParams[`eventIds${chartId}`]?.split(",");

        filtrationStages = [
          ...filtrationStages,
          {
            $match: {
              "event._id": { $in: eventIds.map((id) => ({ $oid: id })) },
            },
          },
        ];
      }
    }
    if (organizationId) {
      filtrationStages = [
        ...filtrationStages,

        {
          $lookup: {
            from: "Organization",
            localField: "event.whiteLabelId",
            foreignField: "whiteLabelId",
            as: "organization",
          },
        },
        {
          $unwind: { path: "$organization", preserveNullAndEmptyArrays: true },
        },
        {
          $match: {
            "organization._id": { $oid: organizationId },
          },
        },
      ];
    }
    if (
      searchParams[`toggle${chartId}`] &&
      !["12 months", "All time"].includes(searchParams[`toggle${chartId}`])
    ) {
      switch (searchParams[`toggle${chartId}`]) {
        case "30 days":
          fromDate = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000);
          toDate = new Date();
          break;
        case "7 days":
          fromDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
          toDate = new Date();
          break;
        case "24 hours":
          fromDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
          toDate = new Date();
          break;
        default:
          fromDate = new Date();
          toDate = new Date();
          break;
      }

      const fromDateStr = fromDate.toISOString() as string;
      const toDateStr = toDate?.toISOString() as string;

      filtrationStages = [
        ...filtrationStages,
        {
          $match: {
            $expr: {
              $and: [
                {
                  $gte: [
                    "$createdAt",
                    {
                      $dateFromString: {
                        dateString: new Date(fromDateStr).toISOString(),
                      },
                    },
                  ],
                },
                {
                  $lte: [
                    "$createdAt",
                    {
                      $dateFromString: {
                        dateString: new Date(toDateStr).toISOString(),
                      },
                    },
                  ],
                },
              ],
            } as any,
          },
        },
      ];
    }

    const stages = [
      { $sort: { _id: -1 } },
      {
        $lookup: {
          from: "Event",
          localField: "eventId",
          foreignField: "_id",
          as: "event",
        },
      },
      { $unwind: { path: "$event", preserveNullAndEmptyArrays: true } },

      ...filtrationStages,
      {
        $lookup: {
          from: "EventCategory",
          localField: "event.categoryId",
          foreignField: "_id",
          as: "category",
        },
      },
      { $unwind: { path: "$category", preserveNullAndEmptyArrays: true } },

      {
        $lookup: {
          from: "EventCategoryTranslations",
          localField: "category._id",
          foreignField: "eventCategoryId",
          as: "event.EventCategoryTranslations",
          pipeline: [
            {
              $lookup: {
                from: "Language",
                localField: "languageId",
                foreignField: "_id",
                as: "language",
              },
            },
            {
              $match: {
                "language.code": lang,
              },
            },
            {
              $project: {
                _id: 0,
                name: 1,
                description: 1,
              },
            },
          ],
        },
      },
      {
        $addFields: {
          translationName: {
            $arrayElemAt: ["$event.EventCategoryTranslations.name", 0],
          },
        },
      },
      {
        $group: {
          _id: "$event.EventCategoryTranslations",
          value: { $sum: 1 },
          name: { $first: "$translationName" },
        },
      },
      {
        $project: {
          _id: 0,
          name: 1,
          value: 1,
        },
      },
      // Sort by value in descending order (highest first)
      { $sort: { value: -1 } },
    ];
    const registrationByEventTypeSummary: any = await prisma.order.aggregateRaw(
      {
        pipeline: stages,
      }
    );
    if (
      registrationByEventTypeSummary == null ||
      !registrationByEventTypeSummary.length
    ) {
      return [];
    }

    return registrationByEventTypeSummary;
  } catch (e: any) {
    console.error(e);
    return [];
  }
};
